<template>
  <div>
    <div class="d-iblock pos-relative">
      <div class="d-flex">
        <div
            v-for="n in max"
            :key="n"
            :class="darker ?  'c-gray70' : 'c-gray30'"
            :selenium="`rating-star-${n}`"
            class="STAR"
            @mouseover="handleMouseOver(n)"
            @mouseout="handleMouseOut"
            @click="handleClick(n)">
          &#9733;
        </div>
      </div>

      <div :style="{ width }" class="FILLED d-flex">
        <div
            v-for="n in max"
            :key="n"
            :class="hoverValue ? 'c-green' : 'c-depot'"
            class="STAR">
          &#9733;
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'rating-stars',
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 5,
    },
    darker: {
      type: Boolean,
      default: false,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      hoverValue: null,
    };
  },
  computed: {
    width () {
      let visibleValue = this.value;

      if (this.interactive) {
        visibleValue = this.hoverValue || this.value;
      }

      const width = (visibleValue / this.max) * 100;

      return `${width}%`;
    },
  },
  methods: {
    handleMouseOver (n) {
      this.hoverValue = n;
      this.$emit('mouse-over', n);
    },
    handleMouseOut () {
      this.hoverValue = null;
      this.$emit('mouse-out');
    },
    handleClick (n) {
      this.$emit('input', n);
      this.hoverValue = null;
    },
  },
};
</script>

<style lang="scss" scoped>
  .STAR {
    transition: color 100ms ease;

    & + & {
      padding-left: 0.1em;
    }
  }

  .FILLED {
    position: absolute;
    top: 0;
    overflow: hidden;
    pointer-events: none;
  }
</style>
